<template>
  <div class="main">
    <p>
      <span class="hover" @click="$router.push('/consultant/newstudent')">新的学生</span>
      >{{name}}-{{sexName}}-{{school}}{{parameter}}
    </p>
    <router-view @event1="change($event)"></router-view>
  </div>
</template>

<script>
export default {
  data(){
    return{
      name:'',
      school:'',
      sexName:'',
      parameter:''
    }
  },
  methods:{
    getData(){
      this.$ajax.post(this.G_acapi + this.ports.consultant.student.new.getStudentDetail,{
        studentId:this.$route.query.studentId
      },{
        headers: {
          token: window.sessionStorage.getItem('ymtxToken')
        }
      }).then(res=>{
        console.log(res)
        if(res.data.code==2000){
          let {name,sexName,school} = res.data.data
          this.name=name;
          this.school=school;
          this.sexName=sexName;
        }else{
        }
      })
    },
    change(data){
      this.parameter=data
    }
  },
  mounted() {
  // this.getData()
  }
}
</script>

<style scoped lang="less">
  *{
    margin: 0;
    padding: 0;
  }
  .main{
    width: 1200px;
    margin:0 auto;
    &>p{
      line-height: 40px;
      font-size: 14px;
    }
  }
  .hover{
    cursor: pointer;
    &:hover{
      color:#0A9BF0;
    }
  }
</style>